var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.986 4 7.841 16.162l3.295 1.672 3.851-6.131 3.092 5.422 3.446-1.875L14.986 4zM6.422 18.493 1 27.767h27.82l-5.117-8.007h-4.156l1.977 3.953H7.84l2.535-4.358-3.953-.862zm8.311 1.318-1.824-1.266 1.823-3.547 2.027 3.547 14.24-7.5-.253 6.993-13.176 1.774 1.623 2.737h-8.818l1.976-2.99 2.383.254z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeam);
export default __webpack_public_path__ + "static/media/BEAM.247213260e11e29a739c5cfce05054ec.svg";
export { ForwardRef as ReactComponent };